import { render, staticRenderFns } from "./TooltipDropdown.vue?vue&type=template&id=0c715da1&scoped=true&"
import script from "./TooltipDropdown.vue?vue&type=script&lang=ts&"
export * from "./TooltipDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./TooltipDropdown.vue?vue&type=style&index=0&id=0c715da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c715da1",
  null
  
)

export default component.exports